import alt from 'js/alt';

class CriteriaActions {
  riskLevelSelection(level) {
    return level;
  }

  soilClassSelection(level) {
    return level;
  }

  standardsVersionSelection(standardsVersion) {
    return standardsVersion;
  }

  measurementsSelection(id) {
    return id;
  }

  loadsClick(id, checked) {
    return { id: id, checked: checked };
  }

  toggleLocationDiv(divID) {
    return divID;
  }

  viewReport() {
    return true;
  }

  updateReadyForReport(value) {
    return value;
  }

  hideReport() {
    return true;
  }

  selectAllLoads() {
    return true;
  }

  updatedSnapToAddress(value) {
    return value;
  }

  setLatLon(latitude, longitude) {
    return { latitude: latitude, longitude: longitude };
  }

  setCheckedLoads(loads) {
    return loads;
  }
}

export const criteriaActions = alt.createActions(CriteriaActions);
